import { render, staticRenderFns } from "./ToolbarTextareaPadding.vue?vue&type=template&id=c4f0b1ce"
import script from "./ToolbarTextareaPadding.vue?vue&type=script&lang=js"
export * from "./ToolbarTextareaPadding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports